"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CSSTransition = require("react-transition-group/CSSTransition");
var classNames = require("classnames");
var ExpandAnimationComponent = /** @class */ (function (_super) {
    __extends(ExpandAnimationComponent, _super);
    function ExpandAnimationComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExpandAnimationComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, show = _a.show, mountOnEnter = _a.mountOnEnter, unmountOnExit = _a.unmountOnExit, className = _a.className, children = _a.children, other = __rest(_a, ["show", "mountOnEnter", "unmountOnExit", "className", "children"]);
        return (React.createElement(CSSTransition, { className: classNames('ee_expand-animation', className, {
                'ee_expand-animation--open': show
            }), classNames: {
                enterActive: 'ee_expand-animation--enter-or-exit',
                exitActive: 'ee_expand-animation--enter-or-exit'
            }, in: show, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, timeout: 300, onEnter: 
            /* istanbul ignore next */ function (node) {
                if (!_this.targetHeight) {
                    _this.targetHeight = node.getBoundingClientRect().height;
                }
                node.style.height = '0';
            }, onEntering: 
            /* istanbul ignore next */ function (node) {
                node.style.height = _this.targetHeight + "px";
            }, onEntered: 
            /* istanbul ignore next */ function (node) {
                node.style.height = '';
            }, onExit: 
            /* istanbul ignore next */ function (node) {
                if (!_this.targetHeight) {
                    _this.targetHeight = node.getBoundingClientRect().height;
                }
                node.style.height = _this.targetHeight + "px";
            }, onExiting: 
            /* istanbul ignore next */ function (node) {
                node.style.height = '0';
            }, onExited: 
            /* istanbul ignore next */ function (node) {
                node.style.height = '';
            } },
            React.createElement("div", __assign({}, other), children)));
    };
    ExpandAnimationComponent.defaultProps = {
        show: false,
        mountOnEnter: false,
        unmountOnExit: false,
        className: undefined
    };
    return ExpandAnimationComponent;
}(React.Component));
exports.default = ExpandAnimationComponent;
//# sourceMappingURL=ExpandAnimationComponent.js.map
